import { useAuth } from "auth/useAuth";

/**
 * Custom hook to get the authentication token from react-oidc-context
 * Automatically sets the token for API calls
 * @returns {Object} Object containing the token and user info
 */
export const useAuthToken = () => {
  const auth = useAuth();
  
  return {
    isAuthenticated: auth.isAuthenticated,
    token: auth.user?.id_token,
    user: auth.user,
    error: auth.error
  };
};

/**
 * Gets the ID token from the auth context
 * @param {Object} auth - The auth object from useAuth hook
 * @returns {string|null} The ID token or null if not available
 */
export const getIdToken = (auth) => {
  if (!auth.isAuthenticated || !auth.user) {
    return null;
  }
  
  return auth.user.id_token;
};

/**
 * Centralized function to setup API authentication
 * Call this once in your app when user is authenticated
 * @param {Object} auth - The auth object from useAuth hook
 */
export const setupApiAuth = (auth) => {
  if (auth.isAuthenticated && auth.user?.id_token) {
    const { setAuthToken } = require('./api_helper');
    setAuthToken(auth.user.id_token);
  }
};